import(/* webpackMode: "eager" */ "/hisea-ssr/src/app/(app)/privacy-policy/loading.js");
